export class TinyHelper {
    /**
     *
     * @param bytes - The size in bytes
     * @returns - The size in MB as a string with 2 decimal places
     */
    public static convertBytesToMB(bytes: number): string {
        return (bytes / 1024 / 1024).toFixed(2);
    }
}
